<template>
  <v-menu
    offset-y
    min-width="290px"
    transition="scale-transition"
    v-model="dateRangeMenu"
    :disabled="disabled || readonly"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="{ ...attrs }" :class="{ 'flex-grow-1': grow }">
        <v-text-field
          readonly
          :label="label"
          :placeholder="label"
          :dense="dense"
          :disabled="disabled"
          :hide-details="hideDetails"
          :class="inputClass"
          :min="min"
          :max="max"
          :prepend-icon="disabled ? 'event_busy' : 'event'"
          :value="rangeDates"
        />
      </div>
    </template>

    <v-date-picker
      no-title
      scrollable
      range
      locale="ru"
      v-model="date"
      :type="type"
      :readonly="readonly"
      :disabled="disabled"
      :min="min"
      :max="max"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="dateRangeMenu = false">Отменить</v-btn>
      <v-btn v-if="!hideClearBtn" text color="primary" @click="clearDateFilter">Очистить</v-btn>
      <v-btn text color="primary" @click="updateDateFilter">Применить</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateRangePicker",
  inheritAttrs: false,

  props: {
    grow: { type: Boolean },
    dense: { type: Boolean },
    hideDetails: { type: Boolean },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideClearBtn: { type: Boolean, default: false },
    inputClass: {
      type: String,
      default: "ma-0 pa-0",
    },
    label: {
      type: String,
      default: "Укажите дату",
    },
    min: { type: String, default: null },
    max: { type: String, default: null },
    type: {
      type: String,
      default: "date",
      validator: function(value) {
        return ["date", "month"].indexOf(value) !== -1;
      },
    },
    value: {},
  },

  data() {
    return {
      dateRangeMenu: false,
      date: [],
    };
  },

  computed: {
    rangeDates() {
      if (Array.isArray(this.value)) {
        return this.value.map(d => this.$date(d).format("DD.MM.YYYY")).join(" - ");
      }

      return this.value;
    },
  },

  mounted() {
    this.date = this.value;
  },

  methods: {
    clearDateFilter() {
      this.dateRangeMenu = false;
      this.$emit("input", []);
    },

    updateDateFilter() {
      this.dateRangeMenu = false;

      if (this.date.length > 1 && Date.parse(this.date[0]) > Date.parse(this.date[1])) {
        this.date = [this.date[1], this.date[0]];
      }

      this.$emit("input", this.date);
    },
  },
};
</script>

<style scoped></style>
